"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createQueryString = void 0;
function createQueryString(params) {
    return Object.keys(params)
        .filter(function (key) { return params[key] !== null && params[key] !== undefined; })
        .map(function (key) { return "".concat(key, "=").concat(encodeURIComponent(params[key])); })
        .join('&');
}
exports.createQueryString = createQueryString;
